<template>
  <!-- 下单填写资料弹框 -->
  <div class="submitDialog">
    <el-dialog
      title="提交订单"
      :visible.sync="submitDialogVisible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      width="900px"
      center
      z-index="1000"
    >
      <el-form ref="formRef" :model="form" label-width="100px" :rules="rules">
        <el-form-item label="取货方式">
          <el-radio-group v-model="form.pictType">
            <el-radio v-for="item in pickTypeOptions" :key="item" :label="item">
              {{ item }}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="网点名称">
          <el-select
            @change="changeNetWork"
            :popper-append-to-body="false"
            filterable
            v-model.trim="form.netAddress"
            placeholder="请选择下单网点名称"
            value-key="orgName"
          >
            <el-option
              v-for="(item, index) in form.organizationList"
              :key="index"
              :label="item.orgCode + '-' + item.orgName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="noOrders" v-if="tips === 'S' || tips === 'F'">
          {{ tips | dotState }}
        </div>
        <el-form-item label="联系人">
          <el-input
            v-model="form.payerName"
            filterable
            placeholder="请输入联系人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="payerContact">
          <el-input
            v-model="form.payerContact"
            maxlength="11"
            @input="inputPhone"
            filterable
            placeholder="请输入联系人电话"
          ></el-input>
        </el-form-item>

        <el-form-item label="收货地址">
          <el-input
            v-model="form.payerAddress"
            maxlength="200"
            filterable
            placeholder="请输入收货地址"
          ></el-input>
        </el-form-item>

        <el-form-item label="备注">
          <el-input
            v-model="form.remark"
            placeholder="请输入您的备注"
            type="textarea"
            :rows="7"
          ></el-input>
        </el-form-item>
        <el-form-item class="submitBTn">
          <div
            style="text-align:center"
            :disabled="tips === 'S' || tips === 'F'"
            class="bottomBox"
          >
            <el-button
              type="primary"
              :disabled="tips === 'S' || tips === 'F'"
              style="width: 370px; height: 52px"
              @click="pushData()"
              >确 定</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { getOrderInfo, getPickType } from '@/api/cartApi'
import { dotState } from '@/utils/filetrs'
import ls from '@/utils/localStorage'

export default {
  name: 'SubmitDialog',
  props: {
    submitDialogVisible: Boolean,
  },
  data() {
    return {
      options: [],
      form: {
        pictType: '',
        remark: '',
        netAddress: '',
        payerName: '',
        payerAddress: '',
        payerContact: '',
        orderType2: '',
      },
      tips: '',
      pickTypeOptions: ['邮寄', '自提'],
      rules: {
        payerContact: [
          {
            pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
            message: '请输入正确的手机号',
            trigger: 'blur',
          },
          { required: true, message: '此项必填', trigger: 'blur' },
        ],
      },
      userData: ls.get('userData'),
    }
  },
  filters: {
    dotState,
  },
  mounted() {
    this.getOrderInfo()
    this.getPickType()
  },
  methods: {
    getPickType() {
      if (this.userData.username === '0114') {
        this.pickTypeOptions = ['自提']
        this.form.pictType = '自提'
        return
      } else {
        getPickType().then((res) => {
          this.pickTypeOptions = res.data || []
          if (this.pickTypeOptions.length) {
            this.form.pictType = this.pickTypeOptions[0]
          }
        })
      }
    },

    //input事件处理
    inputPhone(e) {
      let filtered = e.replace(/[^\d]/g, '')
      if (this.form.payerContact != filtered) {
        this.form.payerContact = filtered
      }
    },
    // 下单确定
    pushData() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$emit('placeOrder', this.form)
        }
      })
    },
    //  改变网点名称
    changeNetWork(value) {
      this.tips = value.status
      //   orderInfor.netCode = from.netAddress.split('-')[0]
      this.form.netCode = value.orgCode
      this.form.netAddress = value.orgName
      this.form.payerAddress = value.address
    },
    getOrderInfo() {
      getOrderInfo().then((res) => {
        if (res.code == 0) {
          this.form = {
            ...this.form,
            ...res.data,
            pictType: this.form.pictType || this.pickTypeOptions[0],
          }
        }
      })
    },
    handleClose() {
      this.$emit('onCloseSelectDialog')
    },
    confirmDel() {
      this.$emit('confirmDel')
    },
  },
}
</script>
<style lang="scss" scoped>
.submitDialog {
  .el-select {
    width: 100%;
  }
  .nameOfbranches {
    margin-top: 46px;
    position: relative;
  }
  /deep/ .nameOfbranches .el-input {
    width: 752px;
  }
  .publicClass {
    height: 64px;
    line-height: 64px;
    margin-top: 20px;
  }
  .el-form-item {
    margin-bottom: 22px !important;
  }
  .submitBTn /deep/.el-form-item__content {
    margin-left: 0 !important;
  }
  .noOrders {
    position: absolute;
    left: 130px;
    top: 123px;
    color: red;
    font-size: 12px;
    font-weight: bold;
  }
  ::v-deep .el-select-dropdown__item {
    margin-top: 5px;
    margin-left: 10px;
    display: inline-block;
    width: 750px;
    height: 46px;
    text-align: center;
    line-height: 46px;
    border: 1px solid #d3d3d3;
    padding: 0;
    font-size: 16px;
    color: #000;
  }
  .el-select-dropdown__item.selected {
    background: #fff2ea;
    font-size: 16px;
    color: #000;
    font-weight: 400;
    border: 1px solid #ee9c75;
  }

  /deep/ .el-radio.is-checked .el-radio__label {
    color: #ec9368 !important;
  }

  /deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #ec9368 !important;
    background: #ec9368 !important;
  }
}
</style>
